import {
  ListWorkOrdersQuery,
  ListWorkOrdersResult,
  WorkorderColumnOrderConfig,
} from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { tableSorterOrder } from '@/utils/table';
import { SorterResult } from 'antd/lib/table/interface';

const getColumnKey = (key: string) =>
  Object.entries(WorkorderColumnOrderConfig).find(
    ([_, queryColumnKey]) => queryColumnKey === key,
  );

const getTableOrder = (order: string) =>
  tableSorterOrder[order] === 'ASC' ? 0 : 1;

export default function workorderOrderColumns(
  sorterList: SorterResult<ListWorkOrdersResult>[],
  setQueryParams: React.Dispatch<React.SetStateAction<ListWorkOrdersQuery>>,
) {
  if (sorterList.length < 1) return;

  setQueryParams((prev) => {
    const currOrderColumns = prev.orderColumns
      ?.split(',')
      .filter((orderColumn) => {
        const [key] = orderColumn.split(':');
        const columnKey = getColumnKey(key)?.[0];

        return sorterList.some((sorter) => sorter.columnKey === columnKey);
      })
      .map((orderColumn) => {
        const [key, curValue] = orderColumn.split(':');

        const columnKey = getColumnKey(key)?.[0];

        const sorter = sorterList.find(
          (sorter) => sorter.columnKey === columnKey,
        );

        const nextValue = sorter
          ? getTableOrder(sorter.order as string)
          : curValue;

        return { key, value: nextValue, sortOrderColumnKey: sorter?.columnKey };
      });

    const nextOrderColumns = sorterList
      .filter(
        (sorter) =>
          !!sorter.order &&
          !currOrderColumns?.some(
            (currOrderColumn) =>
              currOrderColumn.sortOrderColumnKey === sorter.columnKey,
          ),
      )
      .map((sorter) => {
        const key = WorkorderColumnOrderConfig[sorter.columnKey as string];
        const value =
          tableSorterOrder[sorter.order as string] === 'ASC' ? 0 : 1;

        return `${key}:${value}`;
      })
      .join();

    const orderColumns = [
      currOrderColumns
        ?.map((order) => `${order.key}:${order.value}`)
        .join(`,`) || '',
      nextOrderColumns || '',
    ]
      .filter(Boolean)
      .join(',');

    return { ...prev, orderColumns: orderColumns || undefined };
  });
}
